export { default as useCachePaginatedSmartContracts } from './useCachePaginatedSmartContracts';
